/**
 * Motor de evaluación PLD (Nivel 2): determina dueños beneficiarios sugeridos
 * a partir del tipo de operación y la lista de participantes.
 */

/**
 * @param {string} tipoOperacion
 * @param {Array<{ id_nodo: string, sujeto_id: string, rol: string, porcentaje_acciones?: number, es_historico?: boolean }>} participantes
 * @returns {Array<{ id_nodo: string, es_bc: boolean, origen_bc: string, perfil_sugerido: string }>}
 */
export function evaluarOperacionPLD(tipoOperacion, participantes) {
    let resultados = [];
    let existeSocioMayoritario = false;

    participantes.forEach((p) => {
        let es_bc = false;
        let origen_bc = '';
        let perfil = 'CLIENTE_DIRECTO';
        const rolLower = p.rol.toLowerCase();

        if (p.porcentaje_acciones && p.porcentaje_acciones > 25 && !rolLower.includes('socio fundador')) {
            es_bc = true;
            existeSocioMayoritario = true;

            if (rolLower.includes('comprador')) origen_bc = 'Comprador (>25%)';
            else if (rolLower.includes('aportante')) origen_bc = 'Aportante (>25%)';
            else if (rolLower.includes('fundador')) origen_bc = 'Socio Fundador (>25%)';
            else if (p.es_historico) origen_bc = 'Socio Histórico (>25%)';
            else origen_bc = 'Por Propiedad (>25%)';
        }

        // Roles que implican BC por definición, independientemente del %
        if (rolLower.includes('dueño beneficiario') || rolLower.includes('cascada')) {
            es_bc = true;
            existeSocioMayoritario = true;
            if (!origen_bc) origen_bc = 'Beneficiario Controlador (Cascada)';
        }

        if (rolLower.includes('administrador por control')) {
            es_bc = true;
            if (!origen_bc) origen_bc = 'Control Administrativo (BC)';
        }

        if (rolLower.includes('beneficiario controlador')) {
            es_bc = true;
            if (!origen_bc) origen_bc = 'Por determinación directa';
        }

        if (tipoOperacion === 'DISOLUCIÓN Y LIQUIDACIÓN' && rolLower.includes('liquidador')) {
            es_bc = true;
            existeSocioMayoritario = true;
            origen_bc = 'Control por Liquidación';
        }

        if (rolLower.includes('<25%') || (p.porcentaje_acciones && p.porcentaje_acciones <= 25)) {
            perfil = 'SOLO_DATOS';
        }
        if (rolLower.includes('delegado') || rolLower.includes('apoderado') || rolLower.includes('representante legal')) {
            perfil = 'DELEGADO';
        }
        if (rolLower.includes('sociedad') || rolLower.includes('emisora') || rolLower.includes('liquidación') || p.tipo.toLowerCase() === 'moral') {
            perfil = 'SOCIEDAD';
        }

        resultados.push({ id_nodo: p.id_nodo, es_bc, origen_bc, perfil_sugerido: perfil });
    });

    if (!existeSocioMayoritario) {
        resultados = resultados.map((res) => {
            const part = participantes.find((p) => p.id_nodo === res.id_nodo);
            if (part && part.rol.toLowerCase().includes('administrador')) {
                return {
                    ...res,
                    es_bc: true,
                    origen_bc: 'Control Administrativo (Descarte)',
                    perfil_sugerido: 'CLIENTE_DIRECTO',
                };
            }
            return res;
        });
    }

    return resultados;
}
